import React from 'react';
import { useOS } from '../OSContext';
import { getApp } from '../apps';
import skills from '../../../data/skills';

const AboutApp = () => {
	const { openApp } = useOS();

	return (
		<div className="font-os h-full overflow-y-auto bg-os-surface text-os-text">
			<div className="mx-auto max-w-md px-8 py-10">
				<div className="flex flex-col items-center text-center">
					<div className="h-28 w-28 overflow-hidden rounded-2xl border border-white/10 shadow-[0_8px_24px_rgba(0,0,0,0.4)]">
						<img
							src="https://i.ibb.co/60cRjycV/pana-886777-img-only.jpg"
							alt="Sam Togun"
							className="h-full w-full object-cover"
						/>
					</div>

					<h1 className="mt-5 text-xl font-semibold text-os-text">Sam Togun</h1>
					<p className="mt-1 text-sm text-os-textdim">Senior Backend Engineer &amp; Solutions Architect</p>
					<p className="mt-1 flex items-center gap-1.5 text-xs text-os-textdim">
						<i className="fa-solid fa-location-dot" />
						Stavanger, Norway
					</p>

					<button
						onClick={() => openApp(getApp('projects'))}
						className="mt-5 inline-flex items-center gap-2 rounded-lg bg-os-accent px-4 py-1.5 text-sm font-medium text-white transition-colors hover:bg-os-accent/90 active:bg-os-accent/80"
					>
						<i className="fa-solid fa-folder" />
						View Projects
					</button>
				</div>

				<div className="my-8 h-px bg-white/10" />

				<p className="text-sm leading-relaxed text-os-textdim">
					I'm Sam Togun, a Senior Backend Engineer &amp; Solutions Architect. I specialize in building
					scalable, reliable backend systems and cloud solutions for modern businesses. I architect and
					build scalable backend systems that power modern applications. With expertise in cloud
					technologies and microservices, I help businesses achieve reliability and performance at scale.
				</p>

				<div className="my-8 h-px bg-white/10" />

				<div>
					<h2 className="mb-4 text-xs font-semibold uppercase tracking-wide text-os-textdim">
						Skills
					</h2>
					<div className="space-y-4">
						{skills.map(skill => (
							<div key={skill.label}>
								<div className="mb-1.5 flex items-center justify-between text-xs">
									<span className="text-os-text">{skill.label}</span>
									<span className="tabular-nums text-os-textdim">{skill.value}%</span>
								</div>
								<div className="h-1.5 w-full overflow-hidden rounded-full bg-os-surface3">
									<div
										className="h-full rounded-full bg-os-accent"
										style={{ width: `${skill.value}%` }}
									/>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default AboutApp;
